(() => {
  function initialize() {
    const root = document.querySelector('.vg-pdp');
    if (!root || root.dataset.vgReady) return;
    const copy = window.vgProductText || {};
    const escapeText = window.vgProductEscape;
    const label = (key, values = {}) => String(copy[key] || '').replace(/\[(\w+)\]/g, (_, name) => values[name] ?? '');
    root.dataset.vgReady = 'true';
    const main = root.querySelector('#mj-main-img');
    const thumbs = [...root.querySelectorAll('.mj-thumbs [data-full]')];
    const images = thumbs.length ? thumbs.map(button => ({
      src: button.dataset.zoom || button.dataset.full,
      thumb: button.querySelector('img').src,
      alt: button.querySelector('img').alt
    })) : main ? [{ src: main.dataset.zoom || main.src, thumb: main.src, alt: main.alt }] : [];
    const spinStage = root.querySelector('[data-mj-product-360]');
    const spinTrigger = root.querySelector('[data-mj-360-trigger]');
    const spinHome = spinStage?.parentElement;
    const spinIndex = spinStage && spinTrigger ? images.length : -1;
    if (spinIndex >= 0) images.push({ type: 'spin', thumb: spinTrigger.querySelector('img').src });
    const mobile = window.matchMedia('(max-width: 1023px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dialog = document.createElement('dialog');
    dialog.className = 'vg-pdp-viewer';
    dialog.setAttribute('aria-label', copy.product_images);
    dialog.innerHTML = '<div class="vg-viewer-header"><button type="button" data-close aria-label="' + escapeText(copy.close_viewer) + '" title="' + escapeText(copy.close) + '"><span class="material-symbols-outlined" aria-hidden="true">close</span></button></div><div class="vg-viewer-images swiper" aria-label="' + escapeText(copy.product_photos) + '"><div class="swiper-wrapper"></div></div><nav class="vg-viewer-thumbs" aria-label="' + escapeText(copy.choose_photo) + '"></nav><output class="visually-hidden" aria-live="polite" aria-atomic="true"></output>';
    document.body.append(dialog);
    const gallery = dialog.querySelector('.vg-viewer-images');
    const thumbnailRail = dialog.querySelector('.vg-viewer-thumbs');
    let current = 0;
    let slider, returnFocus, scrollPosition, savedBodyStyles, savedOverflow;
    let spinSlide;
    const viewerThumbs = images.map((photo, index) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      if (photo.type === 'spin') {
        slide.classList.add('vg-viewer-spin', 'swiper-no-swiping');
        slide.setAttribute('aria-label', copy.spin_view);
        const poster = document.createElement('img');
        poster.className = 'vg-viewer-spin-poster';
        poster.src = photo.thumb;
        poster.alt = '';
        poster.setAttribute('aria-hidden', 'true');
        slide.append(poster);
        spinSlide = slide;
      } else {
        const zoom = document.createElement('div');
        zoom.className = 'swiper-zoom-container';
        const image = document.createElement('img');
        image.dataset.src = photo.src;
        image.dataset.preview = photo.thumb;
        image.alt = photo.alt;
        image.decoding = 'async';
        image.draggable = false;
        zoom.append(image);
        slide.append(zoom);
      }
      gallery.querySelector('.swiper-wrapper').append(slide);
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', photo.type === 'spin' ? copy.view_360 : label('view_photo', { index: index + 1, total: images.length }));
      const thumbnail = document.createElement('img');
      thumbnail.src = photo.thumb;
      thumbnail.alt = '';
      thumbnail.loading = 'lazy';
      thumbnail.width = 80;
      thumbnail.height = 80;
      button.append(thumbnail);
      if (photo.type === 'spin') {
        const badge = document.createElement('span');
        badge.className = 'vg-viewer-spin-badge';
        badge.textContent = '360\u00b0';
        badge.setAttribute('aria-hidden', 'true');
        button.append(badge);
      }
      button.addEventListener('click', () => show(index));
      thumbnailRail.append(button);
      return button;
    });
    // Move the existing spin stage so dragging, frame caching and playback stay shared.
    function syncSpin(active) {
      if (!spinStage) return;
      if (active && spinStage.parentElement !== spinSlide) {
        spinSlide.append(spinStage);
        window.mjShowProduct360?.(spinTrigger);
      } else if (!active && spinStage.parentElement === spinSlide) {
        window.mjHideProduct360?.();
        spinHome.append(spinStage);
      }
    }
    function syncViewer(index) {
      current = Math.max(0, Math.min(images.length - 1, index));
      syncSpin(dialog.open && current === spinIndex);
      viewerThumbs.forEach((button, position) => button.setAttribute('aria-current', String(position === current)));
      dialog.querySelector('output').textContent = `${current + 1} / ${images.length}`;
      // Fetch the chosen photograph and its neighbors only when the viewer is opened.
      gallery.querySelectorAll('.swiper-slide').forEach((slide, position) => {
        slide.classList.toggle('vg-viewer-active', position === current);
        if (position === spinIndex) return;
        const image = slide.querySelector('img');
        if (Math.abs(position - current) <= 1 && !image.dataset.requested) {
          if (!image.getAttribute('src')) image.src = image.dataset.preview;
          image.dataset.requested = 'true';
          const full = new Image();
          full.onload = () => { image.src = full.src; };
          full.onerror = () => { delete image.dataset.requested; };
          full.src = image.dataset.src;
        }
      });
      viewerThumbs[current]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    }
    function show(index, speed = reducedMotion.matches ? 0 : 300) {
      const target = Math.max(0, Math.min(images.length - 1, index));
      slider?.zoom.out();
      slider?.slideTo(target, speed);
      syncViewer(target);
    }
    window.vgOpenProductImage = trigger => {
      if (!images.length || dialog.open) return;
      window.mjHideProduct360?.();
      let index = trigger === spinTrigger ? spinIndex : thumbs.indexOf(trigger);
      if (index < 0 && main) {
        index = images.findIndex(image => image.src && new URL(image.src, location.origin).pathname === new URL(main.currentSrc || main.src, location.origin).pathname);
      }
      returnFocus = trigger === main ? root.querySelector('[data-vg-gallery-open]') : trigger;
      scrollPosition = window.scrollY;
      savedBodyStyles = ['position', 'top', 'width'].map(key => [key, document.body.style[key]]);
      savedOverflow = document.documentElement.style.overflow;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      if (!slider && window.Swiper) {
        slider = new window.Swiper(gallery, {
          direction: mobile.matches ? 'horizontal' : 'vertical',
          initialSlide: Math.max(0, index),
          speed: reducedMotion.matches ? 0 : 300,
          slidesPerView: 1,
          zoom: { maxRatio: 3, toggle: true },
          mousewheel: { forceToAxis: true, thresholdDelta: 18, thresholdTime: 500 },
          a11y: { enabled: true, slideLabelMessage: label('product_view', { index: '{{index}}', total: '{{slidesLength}}' }) },
          on: { slideChange: swiper => syncViewer(swiper.activeIndex) }
        });
      }
      slider?.update();
      slider?.mousewheel.enable();
      show(Math.max(0, index), 0);
      dialog.querySelector('[data-close]').focus({ preventScroll: true });
    };
    root.querySelector('[data-vg-gallery-open]')?.addEventListener('click', event => window.vgOpenProductImage(event.currentTarget));
    main?.addEventListener('click', () => window.vgOpenProductImage(main));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      slider?.mousewheel.disable();
      syncSpin(false);
      slider?.zoom.out();
      savedBodyStyles?.forEach(([key, value]) => { document.body.style[key] = value; });
      document.documentElement.style.overflow = savedOverflow || '';
      window.scrollTo({ top: scrollPosition, behavior: 'instant' });
      returnFocus?.focus({ preventScroll: true });
    });
    dialog.addEventListener('keydown', event => {
      if (event.defaultPrevented) return;
      const movement = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 }[event.key];
      if (movement) { event.preventDefault(); show(current + movement); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); show(event.key === 'Home' ? 0 : images.length - 1); }
    });
    mobile.addEventListener('change', () => {
      if (!slider) return;
      slider.zoom.out();
      slider.changeDirection(mobile.matches ? 'horizontal' : 'vertical');
      if (dialog.open) { slider.update(); show(current, 0); }
    });

    // Leave pinch/zoom gestures alone; Swiper handles scrolling with a bounded cooldown.
    gallery.addEventListener('wheel', event => {
      if (event.ctrlKey || slider?.zoom?.scale > 1) event.stopImmediatePropagation();
    }, { capture: true, passive: true });

    const track = root.querySelector('.vg-pdp-gallery-track');
    const progress = root.querySelector('.vg-pdp-gallery-progress');
    const slides = [root.querySelector('.mj-main-img-wrap'), ...root.querySelectorAll('.mj-thumbs > button:not(:first-child)')].filter(Boolean);
    if (track && progress && slides.length > 1) {
      const markers = slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', label('show_photo', { index: index + 1 }));
        button.addEventListener('click', () => track.scrollTo({ left: index * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
        progress.append(button);
        return button;
      });
      const syncGallery = () => {
        const active = Math.round(track.scrollLeft / track.clientWidth);
        markers.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      };
      track.addEventListener('scroll', syncGallery, { passive: true });
      mobile.addEventListener('change', () => { track.scrollLeft = 0; syncGallery(); });
      syncGallery();
      // Variant images and the interactive 360 viewer both occupy the first slide.
      const firstSlide = () => { if (mobile.matches) track.scrollTo({ left: 0, behavior: 'auto' }); };
      if (main) new MutationObserver(firstSlide).observe(main, { attributes: true, attributeFilter: ['src'] });
      root.querySelector('[data-mj-360-trigger]')?.addEventListener('click', firstSlide);
    }

    const mainButton = root.querySelector('#product-form-majestic [name="add"]');
    const stickyButton = document.querySelector('#mj-sticky-form button');
    if (mainButton && stickyButton) {
      document.body.classList.add('vg-pdp-mobile-purchase');
      const syncPurchase = () => {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.querySelector('span').textContent = mainButton.textContent.trim();
      };
      new MutationObserver(syncPurchase).observe(mainButton, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      syncPurchase();
      const delivery = root.querySelector('#mj-delivery-top');
      const deliveryCopy = document.querySelector('.vg-pdp-sticky-delivery');
      if (delivery && deliveryCopy) {
        const syncDelivery = () => {
          const text = delivery.textContent.trim();
          deliveryCopy.hidden = !text || text === copy.calculating_shipping;
          deliveryCopy.textContent = text;
        };
        new MutationObserver(syncDelivery).observe(delivery, { childList: true, subtree: true, characterData: true });
        syncDelivery();
      }
    }

    // Shopify's preview iframe is viewport-height; only its visible wrapper is an obstruction.
    function watchPreviewBar() {
      const preview = document.getElementById('PBarNextFrameWrapper');
      if (!preview) return false;
      const update = () => {
        const rect = preview.getBoundingClientRect();
        const visible = rect.height > 0 && rect.height < 160 && rect.bottom >= window.innerHeight - 1;
        document.body.style.setProperty('--vg-preview-offset', `${visible ? rect.height : 0}px`);
      };
      new ResizeObserver(update).observe(preview);
      preview.addEventListener('toggle', update);
      window.addEventListener('resize', update);
      update();
      return true;
    }
    if (!watchPreviewBar()) {
      const previewObserver = new MutationObserver(() => { if (watchPreviewBar()) previewObserver.disconnect(); });
      previewObserver.observe(document.body, { childList: true });
    }

    // Keep numeric sizes in order without changing option IDs or variant resolution.
    root.querySelectorAll('.mj-variant-grid').forEach(grid => {
      const buttons = [...grid.querySelectorAll('button')];
      if (buttons.every(button => /^\d+(\.\d+)?$/.test(button.textContent.trim()))) {
        buttons.sort((a, b) => Number(a.textContent) - Number(b.textContent)).forEach(button => grid.append(button));
      }
      const sync = () => buttons.forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('mj-active'))));
      new MutationObserver(sync).observe(grid, { subtree: true, attributes: true, attributeFilter: ['class'] });
      sync();
    });

    // An explicit variant link represents a customer's selection, unlike Shopify's default.
    const selected = root.dataset.selectedVariant;
    if (selected) {
      const button = [...root.querySelectorAll('[data-variant-id]')].find(item => item.dataset.variantId === selected);
      if (button && !button.disabled) button.click();
      else {
        const map = root.querySelector('#mj-variant-map');
        let variants = [];
        try { variants = JSON.parse(map?.textContent || '[]'); } catch (_) { /* The default state remains selectable. */ }
        const variant = variants.find(item => String(item.id) === selected && item.available);
        variant?.opts.forEach((value, index) => {
          [...root.querySelectorAll('.mj-opt-btn')].find(item => Number(item.dataset.optIndex) === index && item.dataset.optValue === value)?.click();
        });
      }
    }

    const sizeDialog = document.getElementById('mj-size-guide-modal');
    const guide = root.querySelector('#mj-size-toggle button');
    if (sizeDialog && guide) {
      sizeDialog.setAttribute('role', 'dialog');
      sizeDialog.setAttribute('aria-modal', 'true');
      sizeDialog.setAttribute('aria-label', copy.ring_size_guide);
      const close = sizeDialog.querySelector('button');
      close.setAttribute('aria-label', copy.close_size_guide);
      guide.addEventListener('click', () => close.focus());
      sizeDialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') { sizeDialog.style.display = 'none'; guide.focus(); }
        if (event.key === 'Tab') { event.preventDefault(); close.focus(); }
      });
      close.addEventListener('click', () => guide.focus());
    }
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
